import { Route, Routes, Navigate, Outlet } from "react-router-dom";
import Home from "@layouts/Home/Home";
import LandingPage from "@containers/LandingPage/LandingPage";
import Auth from "@layouts/Auth/Auth";
import SignIn from "@containers/SignIn/SignIn";
import SignUp from "@containers/SignUp/SignUp";
import ProductCatalog from "@containers/ProductCatalog/ProductCatalog";
import ProductRegister from "@containers/ProductRegister/ProductRegister";
import ProductDetail from "@containers/ProductDetail/ProductDetail";
import UserManagement from "@containers/UserManagement/UserManagement";
import Cart from "@containers/Cart/Cart";
import Checkout from "@containers/Checkout/Checkout";
import Search from "@containers/Search/Search";
import Producer from "@containers/Producer/Producer";
import AdminDashboard from "@components/AdminDashboard/AdminDashboard";
import AdminUserManagement from "@components/AdminUserManagement/AdminUserManagement";
import Admin from "@containers/Admin/Admin";
import ProducerHub from "@containers/ProducerHub/ProducerHub";
import { useAuth } from "contexts/AuthContext";
import ProducerDetail from "@containers/ProducerDetail/ProducerDetail";
import Complete from "@containers/Checkout/Complete/Complete";
import Transaction from "@containers/Transaction/Transaction";
import OrderDetails from "@components/OrderDetails/OrderDetails";
import AllProducer from "@containers/Producer/AllProducer/AllProducer";
import CreateAd from "@components/CreateAd/CreateAd";

interface TAuthProtectedRoute {
  requireAuth: boolean;
}

const AuthProtectedRoute: React.FC<TAuthProtectedRoute> = ({ requireAuth }) => {
  const { isAuthenticated } = useAuth();

  if (requireAuth && !isAuthenticated) {
    return <Navigate to="/auth" replace />;
  }

  if (!requireAuth && isAuthenticated) {
    return <Navigate to="/products" replace />;
  }

  return <Outlet />;
};

export const Hay2URoute = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />}>
        <Route index element={<Navigate to="/home" replace />} />
        <Route path="home" element={<LandingPage />} />
        <Route path="products" element={<ProductCatalog />} />
        <Route path="product/detail" element={<ProductDetail />} />
        <Route path="/search" element={<Search />} />
        <Route path="/producer" element={<Producer />} />
        <Route path="/producer/all" element={<AllProducer />} />
        <Route element={<AuthProtectedRoute requireAuth={true} />}>
          <Route path="/transaction" element={<Transaction />} />
          <Route path="/transaction/detail" element={<OrderDetails />} />
          <Route path="/producer/detail" element={<ProducerDetail />} />
          <Route path="product/register" element={<ProductRegister />} />
          <Route path="/profile" element={<UserManagement />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/complete" element={<Complete />} />
          <Route path="/producer/hub" element={<ProducerHub />} />
          <Route path="/profile?direct=ads-register" element={<CreateAd />} />
        </Route>
      </Route>

      <Route element={<AuthProtectedRoute requireAuth={false} />}>
        <Route path="/auth" element={<Auth />}>
          <Route index element={<SignIn />} />
          <Route path="signup" element={<SignUp />} />
        </Route>
      </Route>

      <Route path="/admin" element={<Admin />}>
        <Route index element={<AdminDashboard />} />
        <Route path="user" element={<AdminUserManagement />} />
      </Route>
    </Routes>
  );
};
